/** Assemble MediaRecorder chunks (memory or IndexedDB) into a single Blob. */
export function assembleSiteVisitRecordingBlob(parts: BlobPart[], mimeType: string): Blob {
	const type = mimeType || 'audio/webm';
	return new Blob(parts, { type });
}

/** Wait for `MediaRecorder.stop()` so the final `dataavailable` chunk is emitted. */
export function stopMediaRecorderWhenActive(recorder: MediaRecorder | null): Promise<void> {
	if (!recorder || recorder.state === 'inactive') {
		return Promise.resolve();
	}
	return new Promise((resolve) => {
		recorder.addEventListener('stop', () => resolve(), { once: true });
		try {
			recorder.stop();
		} catch {
			resolve();
		}
	});
}

/** Flush pending encoder output before stop (helps when tab/backgrounded or route changes). */
export async function flushAndStopMediaRecorder(recorder: MediaRecorder | null): Promise<void> {
	if (!recorder || recorder.state === 'inactive') {
		return;
	}
	if (recorder.state === 'recording' || recorder.state === 'paused') {
		try {
			recorder.requestData();
		} catch {
			// ignore — not supported on all mime types
		}
	}
	await stopMediaRecorderWhenActive(recorder);
	// Allow `ondataavailable` handlers and IndexedDB writes to finish.
	await new Promise<void>((resolve) => {
		window.setTimeout(resolve, 100);
	});
}
